var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('div',{staticStyle:{"height":"95vh"},attrs:{"id":"container"}}),_c('div',{attrs:{"id":"panel"}})])}]

export { render, staticRenderFns }